<template>
	<div 
		class="flex flex-row w-full gap-[8px]"
		:class="cartOpen ? 'gap-[62px]' : ''"
	>
		<div 
			class="relative w-[80px] h-[80px] flex flex-none rounded-[5px] overflow-hidden"
			:class="cartOpen ? 'px-[0] py-[8px] w-[117px] h-[106px]' : ''"
		>
			<img 
				class="w-full h-full absolute left-0 top-0 z-0 object-cover" src="/src/assets/images/vip_img_2.jpg" alt="item"
			/>

			<div class="w-full h-full absolute left-0 top-0 z-10 vip-gradient"></div>

			<div class="w-full h-full absolute left-0 top-0 z-20 flex justify-center items-center">
				<div class="flex flex-none justify-center h-[24px] w-[24px] items-center bg-secondary-500 rounded-full">
					<span class="material-symbols-rounded text-base text-secondary-900">shopping_basket</span>
				</div>
			</div>

		</div>
		<div 
			class="flex flex-col flex-1 justify-between"
			:class="cartOpen ? '!flex-row items-center justify-between' : ''"
		>
			<div 
				class="flex flex-row justify-between w-full relative pl-[24px]"
				:class="cartOpen ? 'items-center w-fit pl-[0]' : ''"
			>
				<div class="relative group h-fit">
					<tooltip-small 
						class="tooltip absolute opacity-0 -z-10" 
						:class="[
							isTooltipVisible ? 'group-hover:opacity-100 group-hover:z-10' : '',
							!isFirstItem(product) ? 'left-[0] bottom-[35px]' : '',
							isFirstItem(product) ? 'left-[0] top-[35px]' : ''
							]"
						:positionBottom="isFirstItem(product) ? false : true"
						:positionTop="isFirstItem(product) ? true : false"
            :tooltipText="`${product.name}`"
					/>
					<p 
						ref="textElement"
						class="text-primary-700 text-sm font-bold truncate max-w-[125px] select-none"
						:class="cartOpen ? 'max-w-[186px] w-[186px] text-base' : ''"
					>{{ product.name }}</p>
				</div>
				<button 
					class="w-[24px] h-[24px] flex justify-center items-center absolute left-0"
					v-if="!cartOpen"
					@click="handleRemoveFromCart(product)"
				>
					<span class="material-symbols-rounded text-base text-grays-800">delete</span>
				</button>
			</div>
			<p 
				class="text-primary-900 text-base font-bold text-left"
				:class="cartOpen ? ' w-[80px] text-center' : ''"
			>{{product.price}} ₪</p>
			<button 
					class="w-[24px] h-[24px] flex justify-center items-center"
					v-if="cartOpen"
				>
				<span 
					class="material-symbols-rounded text-base text-grays-800"
					:class="cartOpen ? 'text-lg' : ''"	
					@click="handleRemoveFromCart(product)"
				>delete</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapMutations } from "vuex"

export default {
	name: "cart-product-collecting",
	props: {
		cartOpen: {
			type: Boolean,
			required: true,
		},
		cartProducts: {
			type: Array,
			required: true,
		},
		product: {
			type: Object,
			required: true,
		}
	},
	data() {
    return {
      isTooltipVisible: false,
    };
  },
	methods: {
		updateTooltipVisibility() {
      this.$nextTick(() => {
        const textElement = this.$refs.textElement;
        if (textElement) {
          const isTextOverflowing = textElement.scrollWidth > textElement.offsetWidth;
          this.isTooltipVisible = isTextOverflowing;
        }
      })
    },
		isFirstItem(product) {
			return product.id === this.cartProducts[0].id;
		},
		...mapMutations({ 
			removeFromCart: "cart/removeFromCart",
		}),
		handleRemoveFromCart(product) {
			this.removeFromCart(product);
		}
	},
	mounted() {
    this.updateTooltipVisibility();
  },
	watch: {
		cartProducts() {
			this.updateTooltipVisibility();
		},
		cartOpen() {
			this.updateTooltipVisibility();
		}
	}
}
</script>

<style scoped>

.item:last-of-type {
	border: none !important;
}

.vip-gradient{
	background: linear-gradient(270deg,#3F238B 65.63%, #3f238b91 100%, rgba(26, 6, 79, 0.55) 0%);
}

</style>